<template>
  <div class="content-page pb-5 h-100">
    <b-row class="sm-gutters tab-header-section">
      <b-col>
        <div class="content-header">
          <!--Setup Tabs Start-->
          <v-card>
            <v-tabs v-model="tab" background-color="primary">
              <v-tab
                v-for="(menu, index) in MenuList"
                :key="index"
                v-on:click="changeTab(menu.id)"
                v-show="
                  hasRight(Setting.Permission.Read, menu.menuId) && menu.show
                "
              >
                {{ menu.value }}
              </v-tab>
            </v-tabs>
          </v-card>
          <!--Setup Tabs End-->
        </div>
      </b-col>
    </b-row>
    <div class="row">
      <div class="col-12">
        <div class="scroll-area">
          <v-tabs-items v-model="tab" class="transparent-bg p-a-0 h-100">
            <v-tab-item :eager="true" class="h-100">
              <employeeType
                v-if="selectedTab == 'employeeType'"
                ref="refEmployeeType"
              >
              </employeeType>
            </v-tab-item>
            <v-tab-item :eager="true" class="h-100">
              <jobPosition
                v-if="selectedTab == 'jobPosition'"
                ref="refjobPosition"
              >
              </jobPosition>
            </v-tab-item>
            <v-tab-item :eager="true" class="h-100">
              <academic v-if="selectedTab == 'academic'" ref="refAcademic">
              </academic>
            </v-tab-item>
            <v-tab-item :eager="true" class="h-100">
              <skillCert v-if="selectedTab == 'skillCert'" ref="refSkillCert">
              </skillCert>
            </v-tab-item>
            <v-tab-item :eager="true" class="h-100">
              <sourceOfApp
                v-if="selectedTab == 'sourceOfApp'"
                ref="refSourceOfApp"
              >
              </sourceOfApp>
            </v-tab-item>
            <v-tab-item :eager="true" class="h-100">
              <benefit v-if="selectedTab == 'benefit'" ref="refBenefit">
              </benefit>
            </v-tab-item>
            <v-tab-item :eager="true" class="h-100">
              <docType v-if="selectedTab == 'docType'" ref="refDocType">
              </docType>
            </v-tab-item>
            <v-tab-item :eager="true" class="h-100">
              <documentTemplate
                v-if="selectedTab == 'documentTemplate'"
                ref="refDocumentTemplate"
              >
              </documentTemplate>
            </v-tab-item>
            <v-tab-item :eager="true" class="h-100">
              <district v-if="selectedTab == 'district'" ref="refDistrict">
              </district>
            </v-tab-item>
            <v-tab-item :eager="true" class="h-100">
              <bank v-if="selectedTab == 'bank'" ref="refBanks"> </bank>
            </v-tab-item>
            <v-tab-item :eager="true" class="h-100">
              <company v-if="selectedTab == 'company'" ref="refCompany">
              </company>
            </v-tab-item>
            <v-tab-item :eager="true" class="h-100">
              <idDoc v-if="selectedTab == 'idDoc'" ref="refIDDoc"> </idDoc>
            </v-tab-item>
            <v-tab-item :eager="true" class="h-100">
              <maritalStatus
                v-if="selectedTab == 'maritalStatus'"
                ref="refMaritalStatus"
              >
              </maritalStatus>
            </v-tab-item>
            <v-tab-item :eager="true" class="h-100">
              <relationship
                v-if="selectedTab == 'relationship'"
                ref="refRelationship"
              >
              </relationship>
            </v-tab-item>
            <v-tab-item :eager="true" class="h-100">
              <department
                v-if="selectedTab == 'department'"
                ref="refDepartment"
              >
              </department>
            </v-tab-item>
            <v-tab-item :eager="true" class="h-100">
              <team v-if="selectedTab == 'team'" ref="refTeam"> </team>
            </v-tab-item>
            <v-tab-item :eager="true" class="h-100">
              <employStatus
                v-if="selectedTab == 'employStatus'"
                ref="refEmployStatus"
              >
              </employStatus>
            </v-tab-item>
            <v-tab-item :eager="true" class="h-100">
              <assessTemp
                v-if="selectedTab == 'assessTemp'"
                ref="refAssessTemp"
              >
              </assessTemp>
            </v-tab-item>
            <!-- PayProfile move Payroll Page -->
            <!-- <v-tab-item :eager="true" class="h-100">
              <payProfile
                v-if="selectedTab == 'payProfile'"
                ref="refPayProfile"
              >
              </payProfile>
            </v-tab-item> -->
            <v-tab-item :eager="true" class="h-100">
              <payGroup v-if="selectedTab == 'payGroup'" ref="refPayGroup">
              </payGroup>
            </v-tab-item>
            <v-tab-item :eager="true" class="h-100">
              <payType v-if="selectedTab == 'payType'" ref="refPayType">
              </payType>
            </v-tab-item>
            <v-tab-item :eager="true" class="h-100">
              <payMethod v-if="selectedTab == 'payMethod'" ref="refPayMethod">
              </payMethod>
            </v-tab-item>
            <v-tab-item :eager="true" class="h-100">
              <incType v-if="selectedTab == 'incType'" ref="refIncType">
              </incType>
            </v-tab-item>
          </v-tabs-items>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import employeeType from "./S080100-EmployeeType/S080100-EmployeeType.vue";
import jobPosition from "./S080200-JobPosition/S080200-JobPosition.vue";
import academic from "./S080300-Academic/S080300-Academic.vue";
import skillCert from "./S080400-SkillCerts/S080400-SkillCerts.vue";
import sourceOfApp from "./S080500-SourceOfApp/S080500-SourceOfApp.vue";
import benefit from "./S080600-Benefits/S080600-Benefits.vue";
import documentTemplate from "./S080700-DocumentTemplate/S080700-DocumentTemplate.vue";
import docType from "./S081100-DocType/S081100-DocType.vue";
import bank from "./S080900-Banks/S080900-Banks.vue";
import idDoc from "./S081200-IDDoc/S081200-IDDoc.vue";
import district from "./S080800-District/S080800-District.vue";
import company from "./S081000-Company/S081000-Company.vue";
import relationship from "./S081400-Relationship/S081400-Relationship.vue";
import maritalStatus from "./S081300-MaritalStatus/S081300-MaritalStatus.vue";
import department from "./S081500-Department/S081500-Department.vue";
import team from "./S081600-Team/S081600-Team.vue";
import employStatus from "./S081700-EmployStatus/S081700-EmployStatus.vue";
import assessTemp from "./S081800-AssessTemp/S081800-AssessTemp.vue";
import payProfile from "./S081900-PayProfile/S081900-PayProfile.vue";
import payGroup from "./S082000-PayGroup/S082000-PayGroup.vue";
import payType from "./S082100-PayType/S082100-PayType.vue";
import payMethod from "./S082200-PayMethod/S082200-PayMethod.vue";
import incType from "./082300-IncType/S082300-IncType.vue";
import DatePicker from "vue2-datepicker";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import MenuRightSerivce from "@/service/MenuRightService";
import Setting from "@/constants/Settings";
import StoreGetter from "@/constants/StoreGetter";
export default {
  components: {
    DatePicker,
    employeeType,
    jobPosition,
    skillCert,
    academic,
    sourceOfApp,
    benefit,
    docType,
    documentTemplate,
    bank,
    district,
    company,
    idDoc,
    maritalStatus,
    relationship,
    department,
    team,
    employStatus,
    assessTemp,
    payProfile,
    payType,
    payGroup,
    payMethod,
    incType
  },
  data: () => ({
    localization: t,
    langDictEnum: dictEnum,
    Setting: Setting,
    selectedTab: "employeeType",
    tab: "employeeType",
    MenuList: []
  }),
  mounted() {
    var self = this;
    this.getMenuList();
    this.changeTab(self.MenuList[0].id);
  },
  methods: {
    hasRight(key, menuId) {
      return MenuRightSerivce.hasRightInMenu(true, menuId, key);
    },
    getMenuList() {
      const sysParams = this.$store.getters[StoreGetter.sysParams];
      let modClk = true,
        modLv = true,
        modRecu = true,
        modPay = true;
      const clkFind = sysParams.find(
        x => x.ParamCode == Setting.SysParams.ModCLK
      );
      if (clkFind) {
        modClk = clkFind.ParamVal.toLowerCase() === "true";
      }
      const lvFind = sysParams.find(
        x => x.ParamCode == Setting.SysParams.ModLv
      );
      if (lvFind) {
        modLv = lvFind.ParamVal.toLowerCase() === "true";
      }
      const RecuFind = sysParams.find(
        x => x.ParamCode == Setting.SysParams.ModRecu
      );
      if (RecuFind) {
        modRecu = RecuFind.ParamVal.toLowerCase() === "true";
      }
      const PayFind = sysParams.find(
        x => x.ParamCode == Setting.SysParams.ModPay
      );
      if (PayFind) {
        modPay = PayFind.ParamVal.toLowerCase() === "true";
      }

      this.MenuList = [
        {
          id: "employeeType",
          value: t.t(dictEnum.TAB_EmployeeType),
          menuId: Setting.MenuID.S_EmployeeType,
          show: true
        },
        {
          id: "jobPosition",
          value: t.t(dictEnum.TAB_JobPosition),
          menuId: Setting.MenuID.S_JobPosition,
          show: true
        },
        {
          id: "academic",
          value: t.t(dictEnum.TAB_Academic),
          menuId: Setting.MenuID.S_Academic,
          show: modLv || modRecu || modPay
        },
        {
          id: "skillCert",
          value: t.t(dictEnum.TAB_SkillsCerts),
          menuId: Setting.MenuID.S_Skill,
          show: modLv || modRecu || modPay
        },
        {
          id: "sourceOfApp",
          value: t.t(dictEnum.TAB_SourceOfApp),
          menuId: Setting.MenuID.S_SourceofAppli,
          show: modLv || modRecu || modPay
        },
        {
          id: "benefit",
          value: t.t(dictEnum.LBL_BenefitPlan),
          menuId: Setting.MenuID.S_BenefitPlan,
          show: modLv || modRecu || modPay
        },
        {
          id: "docType",
          value: t.t(dictEnum.TAB_DocType),
          menuId: Setting.MenuID.S_DocumentType,
          show: true
        },
        {
          id: "documentTemplate",
          value: t.t(dictEnum.TAB_DocumentTemplate),
          menuId: Setting.MenuID.S_DocumentTemplate,
          show: modLv || modRecu || modPay
        },
        {
          id: "district",
          value: t.t(dictEnum.TAB_District),
          menuId: Setting.MenuID.S_District,
          show: true
        },
        {
          id: "bank",
          value: t.t(dictEnum.TAB_Bank),
          menuId: Setting.MenuID.S_Bank,
          show: true
        },
        {
          id: "company",
          value: t.t(dictEnum.LBL_Company),
          menuId: Setting.MenuID.S_Company,
          show: true
        },
        {
          id: "idDoc",
          value: t.t(dictEnum.LBL_IDDoc),
          menuId: Setting.MenuID.S_IDType,
          show: true
        },
        {
          id: "maritalStatus",
          value: t.t(dictEnum.LBL_MarriedStatus),
          menuId: Setting.MenuID.S_MaritalSatus,
          show: true
        },
        {
          id: "relationship",
          value: t.t(dictEnum.LBL_Relationship),
          menuId: Setting.MenuID.S_Relationship,
          show: true
        },
        {
          id: "department",
          value: t.t(dictEnum.LBL_Department),
          menuId: Setting.MenuID.S_Department,
          show: true
        },
        {
          id: "team",
          value: t.t(dictEnum.LBL_Team),
          menuId: Setting.MenuID.S_Team,
          show: true
        },
        {
          id: "employStatus",
          value: t.t(dictEnum.LBL_Status),
          menuId: Setting.MenuID.S_EmployeeStatus,
          show: true
        },
        {
          id: "assessTemp",
          value: t.t(dictEnum.LBL_Assess),
          menuId: Setting.MenuID.S_Assess,
          show: modRecu
        },
        // {
        //   id: "payProfile",
        //   value: t.t(dictEnum.LBL_PayProfile),
        //   menuId: Setting.MenuID.S_PayProfile,
        //   show: modPay
        // },
        {
          id: "payGroup",
          value: t.t(dictEnum.LBL_PayGroup),
          menuId: Setting.MenuID.S_PayGroup,
          show: modPay
        },
        {
          id: "payType",
          value: t.t(dictEnum.LBL_PayType),
          menuId: Setting.MenuID.S_PayType,
          show: modPay
        },
        {
          id: "payMethod",
          value: t.t(dictEnum.LBL_PayMethod),
          menuId: Setting.MenuID.S_PayMethod,
          show: modPay
        },
        {
          id: "incType",
          value: t.t(dictEnum.LBL_IncType),
          menuId: Setting.MenuID.S_IncType,
          show: modPay
        }
      ];
    },
    changeTab: function(tab) {
      var self = this;
      self.selectedTab = tab;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/S080000-Setup/S080000-Setup.vue